/*
 *
 * OrdersPage constants
 *
 */

enum ActionTypes {
  DEFAULT_ACTION = 'app/OrdersPage/DEFAULT_ACTION',
  FETCH_ORDERS_REQUEST = 'app/OrdersPage/FETCH_ORDERS_REQUEST',
  FETCH_ORDERS_SUCCESS = 'app/OrdersPage/FETCH_ORDERS_SUCCESS',
  FETCH_ORDERS_FAILURE = 'app/OrdersPage/FETCH_ORDERS_FAILURE',
  FETCH_SUPPLIERS_FAILURE = 'app/OrdersPage/FETCH_SUPPLIERS_FAILURE',
  ORDERS_EXPORT_CSV_REQUEST = 'app/OrdersPage/ORDERS_EXPORT_CSV_REQUEST',
  ORDERS_EXPORT_CSV_SUCCESS = 'app/OrdersPage/ORDERS_EXPORT_CSV_SUCCESS',
  ORDERS_EXPORT_CSV_FAILURE = 'app/OrdersPage/ORDERS_EXPORT_CSV_FAILURE',
  EXPORT_CSV = 'app/OrdersPage/EXPORT_CSV',
  SET_FILTER = 'app/OrdersPage/SET_FILTER',
  APPLY_FILTER = 'app/OrdersPage/APPLY_FILTER',
  CLEAR_FILTER = 'app/OrdersPage/CLEAR_FILTER',
  SET_SEARCH = 'app/OrdersPage/SET_SEARCH',
  APPROVE_ORDER_REQUEST = 'app/OrdersPage/APPROVE_ORDER_REQUEST',
  APPROVE_ORDER_SUCCESS = 'app/OrdersPage/APPROVE_ORDER_SUCCESS',
  APPROVE_ORDER_FAILURE = 'app/OrdersPage/APPROVE_ORDER_FAILURE',
  DISAPPROVE_ORDER_REQUEST = 'app/OrdersPage/DISAPPROVE_ORDER_REQUEST',
  DISAPPROVE_ORDER_SUCCESS = 'app/OrdersPage/DISAPPROVE_ORDER_SUCCESS',
  DISAPPROVE_ORDER_FAILURE = 'app/OrdersPage/DISAPPROVE_ORDER_FAILURE',
  REORDER = 'app/OrdersPage/REORDER',
  REORDER_REQUEST = 'app/OrdersPage/REORDER_REQUEST',
  REORDER_SUCCESS = 'app/OrdersPage/REORDER_SUCCESS',
  REORDER_FAILURE = 'app/OrdersPage/REORDER_FAILURE',
  BULK_REORDER = 'app/OrdersPage/BULK_REORDER',
  BULK_REORDER_REQUEST = 'app/OrdersPage/BULK_REORDER_REQUEST',
  BULK_REORDER_SUCCESS = 'app/OrdersPage/BULK_REORDER_SUCCESS',
  BULK_REORDER_FAILURE = 'app/OrdersPage/BULK_REORDER_FAILURE',
  RATING_MODAL_OPEN = 'app/OrdersPage/RATING_MODAL_OPEN',
  RATING_MODAL_CLOSE = 'app/OrdersPage/RATING_MODAL_CLOSE',
  RATE = 'app/OrdersPage/RATE',
  RATE_REQUEST = 'app/OrdersPage/RATE_REQUEST',
  RATE_SUCCESS = 'app/OrdersPage/RATE_SUCCESS',
  RATE_FAILURE = 'app/OrdersPage/RATE_FAILURE',
  LOAD_MORE_ORDERS = 'app/OrdersPage/LOAD_MORE_ORDERS',
  FETCH_TAB_COUNTS_REQUEST = 'app/OrdersPage/FETCH_TAB_COUNTS_REQUEST',
  FETCH_TAB_COUNTS_SUCCESS = 'app/OrdersPage/FETCH_TAB_COUNTS_SUCCESS',
  FETCH_TAB_COUNTS_FAILURE = 'app/OrdersPage/FETCH_TAB_COUNTS_FAILURE',
  APPROVE_ORDERS_REQUEST = 'app/OrdersPage/APPROVE_ORDERS_REQUEST',
  APPROVE_ORDERS_SUCCESS = 'app/OrdersPage/APPROVE_ORDERS_SUCCESS',
  APPROVE_ORDERS_FAILURE = 'app/OrdersPage/APPROVE_ORDERS_FAILURE',
  DECLINE_ORDERS_REQUEST = 'app/OrdersPage/DECLINE_ORDERS_REQUEST',
  DECLINE_ORDERS_SUCCESS = 'app/OrdersPage/DECLINE_ORDERS_SUCCESS',
  DECLINE_ORDERS_FAILURE = 'app/OrdersPage/DECLINE_ORDERS_FAILURE',
}

export default ActionTypes;
